/**
 * Rate limiting utilities for daily generation limit and Gemini API rate limits
 */

/**
 * Check if user has exceeded daily generation limit (3 per day)
 */
export const checkDailyLimit = () => {
  const today = new Date().toDateString();
  const stored = JSON.parse(localStorage.getItem('wtf_usage') || '{}');

  // Reset if new day
  if (stored.date !== today) {
    localStorage.setItem(
      'wtf_usage',
      JSON.stringify({
        date: today,
        count: 0,
      })
    );
    return true; // allowed
  }

  // Check limit
  if (stored.count >= 3) {
    return false; // blocked
  }

  return true; // allowed
};

/**
 * Increment daily usage counter
 */
export const incrementUsage = () => {
  const today = new Date().toDateString();
  const stored = JSON.parse(localStorage.getItem('wtf_usage') || '{}');

  localStorage.setItem(
    'wtf_usage',
    JSON.stringify({
      date: today,
      count: (stored.date === today ? stored.count : 0) + 1,
    })
  );
};

/**
 * Get time remaining until midnight
 */
export const getTimeUntilMidnight = () => {
  const midnight = new Date();
  midnight.setHours(24, 0, 0, 0);
  const timeLeft = midnight - new Date();

  const hours = Math.floor(timeLeft / (1000 * 60 * 60));
  const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  return {
    timeLeft,
    hours,
    minutes,
    seconds,
    formatted: `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
      2,
      '0'
    )}:${String(seconds).padStart(2, '0')}`,
  };
};

/**
 * Check if error is a rate limit error from Gemini API
 */
export const isRateLimitError = (error) => {
  if (!error) return false;

  const isStatus429 = error.status === 429;
  const messageIncludes =
    error.message?.toLowerCase().includes('quota') ||
    error.message?.toLowerCase().includes('rate') ||
    error.message?.toLowerCase().includes('limit') ||
    error.message?.toLowerCase().includes('too many requests');

  return isStatus429 || messageIncludes;
};

/**
 * Rotating funny messages to show during Gemini rate limit wait
 */
export const getRateLimitMessage = () => {
  const messages = [
    'Mercury is in retrograde AND overloaded 😭',
    'Too many Scorpios at once. Classic.',
    'The stars are processing... slowly.',
    'Even the universe has a rate limit fr fr.',
    'Your reading is worth the wait bestie 🌙',
  ];

  const messageIndex = Math.floor(Date.now() / 10000) % messages.length;
  return messages[messageIndex];
};
